module.exports = __webpack_public_path__ + "img/billpay-alternate.f54ff102.png";